import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

function initSentry(app: App, router: Router) {
   if (!['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV)) return;

   Sentry.init({
      app,
      attachProps: true,
      attachStacktrace: true,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV,
      ignoreErrors: [/^Request aborted$/i, /cancel(?:ed|led)/i],
      maxBreadcrumbs: 50,
      release: import.meta.env.VITE_APP_VERSION,
      tracesSampleRate: 0.2,
      trackComponents: true,
      integrations: [
         new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracePropagationTargets: [import.meta.env.VITE_APP_BASE_URL, /^\//],
         }),
      ],
   });

   Sentry.setContext('env', { origin: import.meta.env.VITE_APP_BASE_URL, mode: import.meta.env.VITE_APP_ENV });
}

export { initSentry };
